import React from 'react';
import Help from '../help';
import './titleBar.css';

export const TitleBar = props => {
	const [open, setOpen] = React.useState(props.defaultOpen);

	React.useEffect(() => {
		setOpen(props.defaultOpen);
	}, [props.defaultOpen]);

	const { children, title, openTitle, suffix, onToggle, help, id, className, ...rest } = props;

	const closeIcon = <i className="ml10 fa fa-caret-up pointer" />;
	const openIcon = <i className="ml10 fa fa-caret-down pointer" />;

	return (
		<span className={`title-bar-container ${className}`} data-testid={rest['data-testid']}>
			<div
				className="title-bar"
				onClick={() => {
					setOpen(!open);
					onToggle && onToggle(!open);
				}}
			>
				<span className={children ? 'with-children' : ''}>
					<div className="bar-title pointer">
						<button className="btn-link">
							{open && openTitle ? openTitle : title}
							{help && id && <Help id={`help-${id}`}>{help}</Help>}
						</button>
						{suffix}
					</div>
					{children ? (open ? closeIcon : openIcon) : null}
				</span>
			</div>
			{children ? <div className={`children ${open ? '' : 'noshow'}`}>{children}</div> : null}
		</span>
	);
};

export default TitleBar;
